var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("a-tree-select", {
        staticStyle: { width: "100%" },
        attrs: {
          "tree-data": _vm.treeData,
          "dropdown-style": { maxHeight: "400px", overflow: "auto" },
          placeholder: _vm.placeholder,
          "allow-clear": _vm.allowClear,
          disabled: _vm.disabled,
          multiple: _vm.multiple,
          "show-search": true,
          "tree-node-filter-prop": "title",
          "tree-checkable": _vm.multiple,
          "show-checked-strategy": _vm.SHOW_ALL,
        },
        on: { change: _vm.handleChange, search: _vm.handleSearch },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function (ref) {
              var title = ref.title
              var isLeaf = ref.isLeaf
              return [
                _c(
                  "span",
                  { style: { fontWeight: isLeaf ? "normal" : "bold" } },
                  [_vm._v(_vm._s(title))]
                ),
              ]
            },
          },
        ]),
        model: {
          value: _vm.selectedValue,
          callback: function ($$v) {
            _vm.selectedValue = $$v
          },
          expression: "selectedValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }